// hooks/useIsMobile.js — deteksi viewport mobile (SSR-safe, pakai matchMedia).
// Dipakai untuk switch presentasi tabel↔kartu. Breakpoint default 768px (md).
import { useEffect, useState } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMobile(e.matches);
    mql.addEventListener('change', onChange);
    setMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return mobile;
}
